import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonComponent } from '../button/button.component';

@Component({
	standalone: true,
	imports: [CommonModule, ButtonComponent],
	selector: 'bp-pressable-tile',
	templateUrl: './pressable-tile.component.html',
	styleUrls: ['./pressable-tile.component.scss'],
})
export class PressableTileComponent {
	@Input() buttonText = '';
	@Input() buttonDisabled = false;
	@Output() buttonClicked = new EventEmitter<void>();
	@Output() tileClicked = new EventEmitter<void>();

	pressed = false;
	buttonPressed = false;

	handleTilePress(): void {
		this.pressed = true;
		this.tileClicked.emit();
	}

	handleTileRelease(): void {
		this.pressed = false;
	}

	handleButtonPress(event: TouchEvent | MouseEvent): void {
		event.stopImmediatePropagation();
		this.buttonPressed = true;
		this.buttonClicked.emit();
	}

	handleButtonRelease(event: TouchEvent | MouseEvent): void {
		event.stopImmediatePropagation();
		this.buttonPressed = false;
	}
}
